// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3Hfhz","title":"AfterBackImages_title__3zwO2","images":"AfterBackImages_images__2A_DF"};